var BOG_LINE_GAME_TYPES = {
    ONLY_CRASH: 'ONLY_CRASH',
    ONLY_MARKET: 'ONLY_MARKET',
    MARKET_AND_CRASH: 'MARKET_AND_CRASH',
};
var UPDATED_BET_DATA_KEYS = {
    index: 'index',
    amount: 'amount',
    isBetAccepted: 'isBetAccepted',
};
var UpdatedSoundDataKeys = {
    isSoundOn: 'isSoundOn',
    isSoundOnPrev: 'isSoundOnPrev',
};
var bogLineMinOdd = 1.01;
var defaultMinOdd = 2;
var autoBetCountListConst = [10, 20, 50, 100];
var repliedGamePath = function () { return "/replay"; };
var checkGameIsReplied = function (pathName) { return pathName.includes("/replay"); };
var betSectionIndex = {
    firstIndex: 0,
    secondIndex: 1,
};
var numPadTypes = {
    betAmount: 'betAmount',
    autoCashOutOdd: 'autoCashOutOdd',
};

export { BOG_LINE_GAME_TYPES, UPDATED_BET_DATA_KEYS, UpdatedSoundDataKeys, autoBetCountListConst, betSectionIndex, bogLineMinOdd, checkGameIsReplied, defaultMinOdd, numPadTypes, repliedGamePath };
